import { render, staticRenderFns } from "./InjectionReportModal.vue?vue&type=template&id=0d89b02c&scoped=true&"
import script from "./InjectionReportModal.vue?vue&type=script&lang=js&"
export * from "./InjectionReportModal.vue?vue&type=script&lang=js&"
import style0 from "./InjectionReportModal.vue?vue&type=style&index=0&id=0d89b02c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d89b02c",
  null
  
)

export default component.exports